import { HttpEvent, HttpHandlerFn, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocaleService } from '@any2any/shared';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '~app/services/config.service';
import { OpenapiHttpContext } from './openapi.http-context';

export function apiInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const config = inject(ConfigService);
  const locale = inject(LocaleService);

  const context = request.context;
  if (context instanceof OpenapiHttpContext) {
    const headers = context.processRequestHeaders(getRequestHeaders(locale, request));
    const alteredRequest = request.clone({
      headers: headers.set('X-Api-Key', config.API_KEY),
    });
    return handleResponse(next, alteredRequest ?? request, context);
  }
  return next(request);
}

function getRequestHeaders(localeService: LocaleService,
                           request: HttpRequest<unknown>): HttpHeaders {
  return request.headers.set('Accept-Language', localeService.currentLanguage ?? '*');
}

function handleResponse(handle: HttpHandlerFn,
                        request: HttpRequest<unknown>,
                        context: OpenapiHttpContext): Observable<HttpEvent<unknown>> {
  return handle(request)
    .pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          context.processResponse(event);
        }
      })
    );
}
